import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import container from 'configs/inversify.config';
import moment from 'jalali-moment';
import {NewNotificationDisplayModel, NotificationDisplayModel } from 'models/notification/notification';
import { INotificationRepository } from 'repositories/auth/INotificationRepository';


interface NotificationState {
    notifications: NewNotificationDisplayModel[];
    loading: boolean;
    error: string | null;
}

const initialState: NotificationState = {
    notifications: [],
    loading: false,
    error: null,
};


export const ReduxAction_GetCurrentUserNotifications = createAsyncThunk<{
    notifications: NewNotificationDisplayModel[]
}>('GetNewCurrentUserNotifications', async () => {
    const repository = container.get<INotificationRepository>(Symbol.for("INotificationRepository"));
    const _notifications = await repository.GetAllNotificationInfo({   pageNumber: 0, pageSize: 1000, Filters: {
         ForAdmin: 0, IsSeen:0
       }});
    return {
        notifications: _notifications.rows.filter(m => m.isSeen == false).map(item => ({
            bodyText: item.bodyText,
            createUserName: item.createUserName,
            createDate: moment(item.createDate).locale("fa").format("YYYY/MM/DD").toPersianDigit(),
            createTime: moment(item.createDate).locale("fa").format("HH:mm").toPersianDigit(),
            entityId: item.entityId,
            entityType: item.entityType,
            id: item.id,
            title: item.title,

        }))
    };
});

export const ReduxAction_SeenNotification = createAsyncThunk<number, number>('SeenNotification', async (id: number) => {
    const repository = container.get<INotificationRepository>(Symbol.for("INotificationRepository"));
    const response = await repository.SeenNotification(id);
    return (response && response.status) ? id : 0;
});

export const NotificationSlice = createSlice({
    name: 'notificationsOrEvents',
    initialState: initialState,
    reducers: {
        newNotification: (state, action: PayloadAction<NewNotificationDisplayModel>) => {
            state.notifications = [...state.notifications, { ...action.payload }]
        },
    },
    extraReducers(builder) {
        builder
            .addCase(ReduxAction_GetCurrentUserNotifications.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(ReduxAction_GetCurrentUserNotifications.fulfilled, (state, action: PayloadAction<{
                notifications: NewNotificationDisplayModel[],
            }>) => {
                state.loading = false;
                state.notifications = action.payload.notifications;
            })
            .addCase(ReduxAction_GetCurrentUserNotifications.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'Failed to load items';
            })
            .addCase(ReduxAction_SeenNotification.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(ReduxAction_SeenNotification.fulfilled, (state, action: PayloadAction<number>) => {
                state.loading = false;
                state.notifications = state.notifications.filter(m => m.id != action.payload);
            })
            .addCase(ReduxAction_SeenNotification.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'Failed to load items';
            });
    },
})

export const { newNotification } = NotificationSlice.actions

export default NotificationSlice.reducer